import { isObject } from 'lodash-es';

import type { SearchCriteriaRangeFilterSchema } from '@iconik-io/iconik-api/src/services/search';
import type { FilterValue } from '@iconik-io/shared-lib/src/redux/common_filters/types';

import type { SelectOption } from '../../ui/select_field/types';

const isSelectOption = (value: unknown): value is SelectOption =>
  isObject(value) &&
  'label' in value &&
  'value' in value &&
  typeof value.label === 'string' &&
  typeof value.value === 'string';

export const guardFilterGeneric = (
  filterValue: FilterValue,
): string[] | undefined => {
  if (!Array.isArray(filterValue) || filterValue.length === 0) {
    return undefined;
  }
  if (filterValue.every((item) => typeof item === 'string')) {
    return filterValue;
  }
  if (filterValue.every(isSelectOption)) {
    return filterValue.map((item) => item.value);
  }
  return undefined;
};

export const guardFilterString = (
  filterValue: FilterValue,
): string | undefined => {
  if (typeof filterValue === 'string') {
    return filterValue;
  }
  return undefined;
};

export const guardFilterRange = (
  filterValue: FilterValue,
): SearchCriteriaRangeFilterSchema | undefined => {
  if (!Array.isArray(filterValue) && isObject(filterValue)) {
    return filterValue;
  }
  return undefined;
};
